// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2YIeX","title":"Info_title__nDWX7","links":"Info_links__13adm","link":"Info_link__19hfq","logo":"Info_logo__35wgA"};